function initGoogleMap(directionLink) {
  const mapContainer = document.getElementById("store-map");
  if (!mapContainer) return;

  mapContainer.innerHTML = "";

  if (!directionLink) {
    mapContainer.innerHTML = "<p>No map available</p>";
    return;
  }

  let embedLink;

  const dirMatch = directionLink.match(/\/dir\/([^/?]+)/);

  if (dirMatch) {
    const destination = decodeURIComponent(dirMatch[1]);
    embedLink = `https://www.google.com/maps?q=${encodeURIComponent(destination)}&output=embed`;
  } else if (directionLink.includes("google.com/maps")) {
    const separator = directionLink.includes('?') ? '&' : '?';
    embedLink = `${directionLink}${separator}output=embed`;
  } else {
    const encodedAddress = encodeURIComponent(directionLink);
    embedLink = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;
  }

  const iframe = document.createElement("iframe");
  iframe.src = embedLink;
  iframe.width = "100%";
  iframe.height = "250";
  iframe.style.border = "0";
  iframe.loading = "lazy";

  mapContainer.appendChild(iframe);
}

function initSlider(container) {
  const sliderWrapper = container.querySelector('.slider-wrapper');
  const prevBtn = container.querySelector('.prevBtn');
  const nextBtn = container.querySelector('.nextBtn');
  if (!sliderWrapper || !prevBtn || !nextBtn) return;

  function updateButtons() {
    const maxScroll = sliderWrapper.scrollWidth - sliderWrapper.clientWidth;
    prevBtn.classList.toggle('hidden', sliderWrapper.scrollLeft <= 0);
    nextBtn.classList.toggle('hidden', sliderWrapper.scrollLeft >= maxScroll - 1);
  }

  updateButtons();

  prevBtn.addEventListener('click', () => {
    sliderWrapper.scrollBy({ left: -260, behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', () => {
    sliderWrapper.scrollBy({ left: 260, behavior: 'smooth' });
  });
  sliderWrapper.addEventListener('scroll', updateButtons);

  let isDown = false,
      lastX = 0,
      velocity = 0,
      raf;

  const stopMomentum = () => cancelAnimationFrame(raf);

  const momentum = () => {
    sliderWrapper.scrollLeft -= velocity;
    velocity *= 0.94;
    if (Math.abs(velocity) > 0.4) {
      raf = requestAnimationFrame(momentum);
    }
  };

  sliderWrapper.addEventListener('mousedown', (e) => {
    isDown = true;
    sliderWrapper.classList.add('dragging');
    lastX = e.pageX;
    stopMomentum();
  });

  sliderWrapper.addEventListener('mouseleave', () => {
    if (isDown) {
      isDown = false;
      sliderWrapper.classList.remove('dragging');
      momentum();
    }
  });

  sliderWrapper.addEventListener('mouseup', () => {
    if (isDown) {
      isDown = false;
      sliderWrapper.classList.remove('dragging');
      momentum();
    }
  });

  sliderWrapper.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX;
    const dx = x - lastX;
    lastX = x;
    velocity = dx;
    sliderWrapper.scrollLeft -= dx;
  });

  sliderWrapper.addEventListener('touchstart', (e) => {
    lastX = e.touches[0].pageX;
    stopMomentum();
  });

  sliderWrapper.addEventListener('touchmove', (e) => {
    const x = e.touches[0].pageX;
    const dx = x - lastX;
    lastX = x;
    velocity = dx;
    sliderWrapper.scrollLeft -= dx;
  });

  sliderWrapper.addEventListener('touchend', () => {
    momentum();
  });
}

// Base endpoint. Detail for a single store is GET {LOCATIONS_ENDPOINT}/{key}
const LOCATIONS_ENDPOINT = 'https://app.stosh.au/api/v1/store-front/locations';

// Fallback used only if a nearby_locations entry ever carries a "key" but no
// "url" — builds a same-shop relative link. Adjust if your page handle differs.
const STORE_PAGE_BASE = '/pages';

// Extracts the coordinates/address from a "/dir/<destination>" style Google Maps
// link and rebuilds it as a proper directions URL where that value is explicitly
// the destination (not the origin, which is what a bare /dir/<value> link means).
function buildDirectionsUrl(directionLink) {
  if (!directionLink) return null;

  const dirMatch = directionLink.match(/\/dir\/([^/?]+)/);
  const destination = dirMatch
    ? decodeURIComponent(dirMatch[1])
    : directionLink;

  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}

async function fetchStoreDetail(key) {
  const response = await fetch(`${LOCATIONS_ENDPOINT}/${encodeURIComponent(key)}`);

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  const json = await response.json();
  return json.data;
}

async function loadLocationData() {
  const section = document.querySelector('section[data-store-locator-url]');
  const { storeLocatorUrl, storeLocatorTitle, phoneIconUrl } = section ? section.dataset : {};

  try {
    // breadcrumbs
    const breadcrumbsList = document.querySelector('nav.n6br[aria-label="breadcrumbs"] > ol');
    if (!breadcrumbsList) {
      console.warn('Breadcrumb not added: no <nav aria-label="breadcrumbs"><ol> found on this page.');
    } else if (!storeLocatorUrl || !storeLocatorTitle) {
      console.warn(
        `Breadcrumb not added: missing data attribute(s) on <section>. storeLocatorUrl="${storeLocatorUrl}", storeLocatorTitle="${storeLocatorTitle}". Check that pages['store-locator'] exists in Shopify admin.`
      );
    } else {
      const lastBreadcrumbsItem = breadcrumbsList.querySelector("li:last-child");
      if (lastBreadcrumbsItem) {
        const storesBreadcrumb = document.createElement("li");
        storesBreadcrumb.innerHTML = `<a href="${storeLocatorUrl}" title="${storeLocatorTitle}">${storeLocatorTitle}</a>`;
        lastBreadcrumbsItem.before(storesBreadcrumb);
      } else {
        console.warn('Breadcrumb not added: breadcrumb <ol> has no <li> children to insert before.');
      }
    }

    const key = window.location.pathname
      .split("/")
      .filter(Boolean)
      .pop();

    const safeRedirectToLocator = () => {
      // Never redirect while previewing in the theme editor — it makes editing
      // painful and can trigger reload loops as Shopify re-renders sections.
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        console.warn('In theme editor — skipping redirect to store locator.');
        return;
      }

      if (storeLocatorUrl && storeLocatorUrl !== window.location.pathname) {
        window.location.href = storeLocatorUrl;
      } else {
        console.warn(
          `Cannot redirect: storeLocatorUrl is missing or matches the current page ("${storeLocatorUrl}").`
        );
      }
    };

    // if (!key) {
    //   safeRedirectToLocator();
    //   return;
    // }

    // let store;
    // try {
    //   store = await fetchStoreDetail(key);
    // } catch (err) {
    //   console.warn(`Could not load store for key "${key}":`, err.message);
    //   safeRedirectToLocator();
    //   return;
    // }

    // if (!store) {
    //   console.warn(`No store returned for key "${key}".`);
    //   safeRedirectToLocator();
    //   return;
    // }

    if (!key) {
      console.warn("No store key found.");
      return;
    }

    let store;
    try {
      store = await fetchStoreDetail(key);
    } catch (err) {
      console.error(
        `Could not load store for key "${key}":`,
        err.message
      );
      return;
    }

    if (!store) {
      console.warn(`No store returned for key "${key}".`);
      return;
    }

    // --- OPENING HOURS ---
    const hoursContainer = document.getElementById("hours-content");

    if (hoursContainer) {
      hoursContainer.innerHTML = "";

      const openingArray = store.opening_hours || [];
      const opening = openingArray.reduce((acc, line) => {
        const colonIndex = line.indexOf(":");
        if (colonIndex === -1) return acc;
        const day = line.slice(0, colonIndex).trim().toLowerCase();
        const time = line.slice(colonIndex + 1).trim();
        if (day) acc[day] = time;
        return acc;
      }, {});

      const days = [
        ["monday", "Monday", true],
        ["tuesday", "Tuesday", true],
        ["wednesday", "Wednesday", true],
        ["thursday", "Thursday", true],
        ["friday", "Friday", true],
        ["saturday", "Saturday", false],
        ["sunday", "Sunday", false],
        ["public", "Public Holiday", false]
      ];

      const validDays = days.filter(([key]) => opening[key] !== undefined);

      if (!validDays.length) {
        hoursContainer.innerHTML = "<p>No opening hours available</p>";
      } else {
        let grouped = [];
        let currentGroup = null;

        validDays.forEach(([key, label, isWeekday], i) => {
          const time = opening[key];
          const displayTime = !time || time.toLowerCase() === "closed" ? "Closed" : time;

          if (isWeekday) {
            if (!currentGroup) {
              currentGroup = { start: label, end: label, time: displayTime };
            } else if (currentGroup.time === displayTime) {
              currentGroup.end = label;
            } else {
              grouped.push({ ...currentGroup, isWeekday: true });
              currentGroup = { start: label, end: label, time: displayTime };
            }

            if (i === validDays.length - 1) {
              grouped.push({ ...currentGroup, isWeekday: true });
              currentGroup = null;
            }
          } else {
            if (currentGroup) {
              grouped.push({ ...currentGroup, isWeekday: true });
              currentGroup = null;
            }
            grouped.push({ start: label, end: label, time: displayTime, isWeekday: false });
          }
        });

        grouped.forEach(g => {
          const p = document.createElement("p");
          const label = g.start === g.end ? g.start : `${g.start} - ${g.end}`;
          if (g.isWeekday) p.classList.add("highlighted");

          const displayTime = label === "Public Holiday"
            ? g.time.replace(/\n/g, "<br>")
            : g.time;

          p.innerHTML = `<span>${label}:</span> ${displayTime}`;
          hoursContainer.appendChild(p);
        });

        if (store.website) {
          const websiteEl = document.createElement("p");
          websiteEl.innerHTML = `<span>Visit us at:</span> <a href="${store.website}" class="location-info-link">${store.website}</a>`;
          hoursContainer.appendChild(websiteEl);
        }
      }

      // Images — API already returns full URLs, no prefix needed
      const imagesContainer = document.querySelector("#hours-images .slider-wrapper");
      const images = store.images || [];
      if (imagesContainer) {
        const uniqueImages = [...new Set(images)];
        imagesContainer.innerHTML = uniqueImages.length
          ? uniqueImages.map(imageUrl => `
              <div class="slide">
                <a href="${imageUrl}" data-fancybox="gallery">
                  <img src="${imageUrl}" width="100" height="100" class="location-image">
                </a>
              </div>
            `).join("")
          : "";
      }
    }

    // --- STORE DETAILS ---
    document.getElementById("store-address").textContent = store.address || "No address available";
    document.getElementById("store-phone").textContent = store.phone || "No phone available";
    document.getElementById("store-email").textContent = store.email || "No email available";

    const phoneLink = document.getElementById("store-phone-link");
    if (phoneLink && store.phone) phoneLink.href = "tel:" + store.phone.replace(/\s+/g, "");

    const emailLink = document.getElementById("store-email-link");
    if (emailLink && store.email) emailLink.href = "mailto:" + store.email;

    const directionsLink = document.getElementById("store-directions");
    if (directionsLink) {
      const directionsUrl = buildDirectionsUrl(store.direction_link);
      if (directionsUrl) {
        directionsLink.href = directionsUrl;
      } else {
        directionsLink.style.display = "none";
      }
    }

    // --- MAP ---
    initGoogleMap(store.direction_link);

    // --- SERVICES GRID ---
    const servicesGrid = document.getElementById("services-grid");
    if (servicesGrid) {
      const services = store.services || [];
      servicesGrid.innerHTML = services.length
        ? services.map(s => {
            const iconHtml = s.icon ? `<img src="${s.icon}" alt="icon">` : '';
            return `<div class="service-item">${iconHtml}${s.title}</div>`;
          }).join('')
        : "<p>No services available</p>";
    }

    // --- SERVICE CARDS (IMMUNISATIONS) ---
    const serviceCards = document.querySelector("#service-cards .slider-wrapper");
    if (serviceCards) {
      const immunisations = store.immunization_services || [];
      serviceCards.innerHTML = immunisations.length
        ? immunisations.map(i => `
            <div class="slide">
              <div class="service-card">
                <div class='h4'>${i.title}</div>
                <p>${i.description}</p>
                <a href="${i.booking_url}" class="location-info-btn">Book Now</a>
              </div>
            </div>`).join("")
        : "<p>No immunisation services available</p>";
    }

    // --- NEARBY STORES ---
    // nearby_locations currently only carries {id, name, address}. Once the
    // backend adds "key" (and ideally "url"/"phone") to each entry, this will
    // automatically start linking and showing phone numbers with no further
    // changes needed — it checks for those fields and falls back gracefully
    // if they're absent.
    const nearbyList = document.getElementById("nearby-store-list");
    if (nearbyList) {
      const nearby = store.nearby_locations || [];

      nearbyList.innerHTML = nearby.length
        ? nearby.map(ns => {
            const url = ns.url || (ns.key ? `${STORE_PAGE_BASE}/${ns.key}` : null);
            const phone = ns.phone || '';

            const phoneMarkup = phone
              ? `<p class="store-contact"><a class="location-info-link" href="tel:${phone.replace(/\s+/g, "")}">
                  <img src="${phoneIconUrl}" alt="icon" width="16" height="16" />
                  ${phone}
                </a></p>`
              : '';

            const nameMarkup = url
              ? `<a href="${url}">${ns.name}</a>`
              : ns.name;

            return `
              <div class="nearby-store-item">
                <div class="store-name h3">${nameMarkup}</div>
                <p class="store-address">${ns.address || ''}</p>
                ${phoneMarkup}
              </div>`;
          }).join("")
        : "<p>No nearby stores available</p>";
    }

  } catch (err) {
    console.error("Error loading location data", err);
  }

  document.querySelectorAll('.slider-container').forEach(container => initSlider(container));
  if (typeof fancyboxEvt !== 'undefined') {
    window.dispatchEvent(fancyboxEvt);
  }
}

document.addEventListener("DOMContentLoaded", loadLocationData);
document.addEventListener("shopify:section:load", loadLocationData);